import React from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

function UploadPhotos() {

  return (
    <div>

      <Navbar />
      <Sidebar />
       
      <div className="uploadphotos-container">

      


        <h1>Upload Photos</h1>

        <div className="section-card">

          <label>Plot Number</label>

          <input
            type="text"
            placeholder="Enter Plot Number"
          />

          <br /><br />

          <label>Select Image</label>

          <input
            type="file"
          />

          <br /><br />

          <button>
            Upload
          </button>
        </div>

      

      </div>

    </div>
  );
}

export default UploadPhotos;